export interface AlainThemeHttpClientConfig {
  /**
   * ç©ºå¼å¤çï¼é»è®¤ï¼`include`
   * - includeï¼åå«
   * - ignoreï¼å¿½ç¥
   */
  nullValueHandling?: 'include' | 'ignore';
  /**
   * æ¶é´å¼å¤çï¼é»è®¤ï¼`timestamp`
   * - timestampï¼æ¶é´æ³
   * - ignoreï¼å¿½ç¥å¤çï¼ä¿æåå§ç¶æ
   */
  dateValueHandling?: 'timestamp' | 'ignore';
}
